import t from 'react-translate';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/react';

import { getAiRolePlay } from 'redux/selectors/timeline';
import { getCurrentUser } from 'redux/selectors/users';

import {
  ReactComponent as AIPersona,
} from 'styles/icons/ai-persona.svg';
import ProfilePicture from 'org_level_profile/components/profile-picture';
import { shortBar, standardSpacing, tripleSpacing } from 'styles/global_defaults/scaffolding';
import AiConversationContext from './context';

const styles = css`
  align-items: flex-start;
  gap: ${standardSpacing}px;
  .profile {
    width: ${shortBar}px;
  }
`;
const AvatarContainer = () => {
  const {
    aiRolePlayId,
  } = useContext(AiConversationContext);

  const aiRolePlay = useSelector((state) => getAiRolePlay(state, aiRolePlayId));
  const currentUser = useSelector(getCurrentUser);

  const {
    aiCharacterName,
    aiCharacterRole,
    learnerRole,
  } = aiRolePlay || {};

  return (
    <div className='d-flex justify-content-center' css={styles}>
      <div className='profile d-flex flex-column align-items-center mt-1'>
        <AIPersona
          width={tripleSpacing}
          height={tripleSpacing}
          role='img'
          aria-label={t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.AI_CHARACTER_AVATAR()}
        />
        <p className='mb-0 mt-2 text-regular semi-bold text-align-center'>{aiCharacterName}</p>
        <p className='mb-0 text-small text-gray-2 text-align-center'>{aiCharacterRole}</p>
      </div>
      <div className='profile d-flex flex-column align-items-center mt-1'>
        <ProfilePicture
          profile={currentUser}
          isRound
          size={tripleSpacing}
        />
        <p className='mb-0 mt-2 text-regular semi-bold text-align-center'>{t.LECTURE_PAGES.COMPONENTS.AI_ROLE_PLAY.CONVERSATION_MODAL.YOU()}</p>
        <p className='mb-0 text-small text-gray-2 text-align-center'>{learnerRole}</p>
      </div>
    </div>
  );
};

export default AvatarContainer;
